<div class="page-header-container">
  <md-page-header [title]="logisticPartnerItem()?.name?.fi ?? ''" icon="partner"></md-page-header>
  <md-info [item]="logisticPartnerItem()" [fields]="infoFields()" [pricingRouteLabel]="'INFO.GO_TO_PRICES'" [pricingType]="'logistics'"> </md-info>
  <md-audit-trail [auditTrail]="auditTrail()"></md-audit-trail>
</div>
